import { AvatarWithName } from '@ingenico/react-ui';
import type { ReactElement } from 'react';
import styles from './AvatarWithNameListCol.module.scss';
import classNames from 'classnames';

interface AvatarWithNameProps {
  readonly name: string;
  readonly className?: string;
  readonly isColumnCell?: boolean;
  readonly avatarClassName?: string;
  readonly infoClassName?: string;
}

export function AvatarWithNameListCol({
  name,
  className,
  isColumnCell,
  avatarClassName,
  infoClassName,
}: AvatarWithNameProps): ReactElement {
  return (
    <AvatarWithName
      name={name}
      className={className}
      isColumnCell={isColumnCell}
      avatarClassName={avatarClassName}
      infoClassName={classNames(infoClassName, styles.info)}
    />
  );
}
